import { AppTileBroadcastMessage } from '@app/models/app-tile-broadcast-message';
import { ChannelTermBroadcastMessage } from '@app/models/channel-term-broadcast-message';
import { parseISO } from 'date-fns';

export enum BroadcastType {
  Critical = 1,
  Warning = 2,
  Information = 3
}

export class BroadcastMessage {
  public Id: number;
  public BroadcastType: BroadcastType;
  public Title: string;
  public Target?: string;
  public LinkUrl?: string;
  public LinkText?: string;
  public Message: string;
  public StartDate?: string;
  public EndDate?: string;
  public Modified?: string;
  public Hidden?: boolean;
  public StartDateAsDate?: Date;
  public EndDateAsDate?: Date;
  public ChannelTermBroadcastMessages: Array<ChannelTermBroadcastMessage>;
  public LanguageTermId?: string;
  public AppTileBroadcastMessages: Array<AppTileBroadcastMessage>;
  public Notify: boolean;

  constructor(opt?: Partial<BroadcastMessage>) {

    if (opt && opt.StartDate && typeof opt.StartDate === 'string') {
      opt.StartDateAsDate = parseISO(opt.StartDate);
    }

    if (opt && opt.EndDate && typeof opt.EndDate === 'string') {
      opt.EndDateAsDate = parseISO(opt.EndDate);
    }

    if (opt && opt.LinkUrl === '') {
      opt.LinkUrl = null;
    }

    Object.assign(this, opt);
  }
}
